import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { observer } from "mobx-react";
import React from "react";
import styled, { css } from "styled-components";
import { EventIcon } from "@faire/retailer/components/Events/shared/EventIcon";
import { useEventsStore } from "@faire/retailer/stores/domain/Events/shared/EventsStore";
export var PromoLineVariant;
(function(PromoLineVariant) {
    PromoLineVariant["DEFAULT"] = "default";
    PromoLineVariant["SMALL"] = "small";
})(PromoLineVariant || (PromoLineVariant = {}));
var EventPromoLineBase = function(param) {
    var text = param.text, variant = param.variant, centered = param.centered, fullWidth = param.fullWidth, border = param.border, mediumText = param.mediumText;
    var _nextOrActiveEventTheme_eventsThemeColors;
    var _useEventsStore = useEventsStore([
        "isMarketEvent",
        "nextOrActiveEventTheme"
    ]), isMarketEvent = _useEventsStore.isMarketEvent, nextOrActiveEventTheme = _useEventsStore.nextOrActiveEventTheme;
    var properPadding = variant === PromoLineVariant.SMALL ? getSpacing(10, "2x", 10, "1x") : getSpacing(12, "2x", 12, "2x");
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: nextOrActiveEventTheme,
        children: /*#__PURE__*/ _jsxs(Container, {
            $padding: properPadding,
            $alignItems: "center",
            $centered: centered,
            $background: (_nextOrActiveEventTheme_eventsThemeColors = nextOrActiveEventTheme.eventsThemeColors) === null || _nextOrActiveEventTheme_eventsThemeColors === void 0 ? void 0 : _nextOrActiveEventTheme_eventsThemeColors.lightBackground,
            $fullWidth: fullWidth,
            $border: border,
            children: [
                /*#__PURE__*/ _jsx(Column, {
                    children: /*#__PURE__*/ _jsx(EventIcon, {
                        size: isMarketEvent ? getSpacing("3x") : getSpacing("2x")
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: variant === PromoLineVariant.SMALL ? "1x" : "2x"
                }),
                /*#__PURE__*/ _jsx(Column, {
                    children: /*#__PURE__*/ _jsx(SingleLineTypography, {
                        variant: mediumText ? "paragraphSansMedium" : "paragraphSansRegular",
                        children: text
                    })
                })
            ]
        })
    });
};
export var EventPromoLine = observer(EventPromoLineBase);
var SingleLineTypography = styled(Typography).withConfig({
    componentId: "sc-c9304fe2-0"
})([
    "&&&{line-height:unset;color:",
    ";}"
], function(props) {
    var _props_theme_eventsThemeColors;
    return (_props_theme_eventsThemeColors = props.theme.eventsThemeColors) === null || _props_theme_eventsThemeColors === void 0 ? void 0 : _props_theme_eventsThemeColors.promoText;
});
// eslint-disable-next-line @faire/prefer-slate-attrs -- move align and justify to a prop
var Container = styled(Row).withConfig({
    componentId: "sc-c9304fe2-1"
})([
    "",
    " padding:",
    ";align-items:",
    ";background:",
    ";justify-content:",
    ";",
    ""
], function(props) {
    return props.$border ? css([
        "border:1px solid ",
        ";"
    ], Core.border.muted) : null;
}, function(props) {
    return props.$padding;
}, function(props) {
    var _props_$alignItems;
    return (_props_$alignItems = props.$alignItems) !== null && _props_$alignItems !== void 0 ? _props_$alignItems : "flex-start";
}, function(props) {
    var _props_theme_eventsThemeColors;
    return (_props_theme_eventsThemeColors = props.theme.eventsThemeColors) === null || _props_theme_eventsThemeColors === void 0 ? void 0 : _props_theme_eventsThemeColors.lightBackground;
}, function(props) {
    return props.$centered ? "center" : "left";
}, function(props) {
    return props.$fullWidth ? css([
        "width:100%;"
    ]) : null;
});
